/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountOptionDtoFromJSON, AccountOptionDtoToJSON, } from './AccountOptionDto';
/**
 * @export
 */
export const AgendaCommercialeFilterOptionsDtoStatiOpportunityEnum = {
    ClosedLost: 'CLOSED_LOST',
    Discovery: 'DISCOVERY',
    MilestonePlanning: 'MILESTONE_PLANNING',
    NegotiationReview: 'NEGOTIATION_REVIEW',
    ProposalPriceQuote: 'PROPOSAL_PRICE_QUOTE',
    Prospecting: 'PROSPECTING',
    Qualification: 'QUALIFICATION'
};
/**
 * Check if a given object implements the AgendaCommercialeFilterOptionsDto interface.
 */
export function instanceOfAgendaCommercialeFilterOptionsDto(value) {
    return true;
}
export function AgendaCommercialeFilterOptionsDtoFromJSON(json) {
    return AgendaCommercialeFilterOptionsDtoFromJSONTyped(json, false);
}
export function AgendaCommercialeFilterOptionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accounts': json['accounts'] == null ? undefined : (json['accounts'].map(AccountOptionDtoFromJSON)),
        'statiOpportunity': json['statiOpportunity'] == null ? undefined : json['statiOpportunity'],
    };
}
export function AgendaCommercialeFilterOptionsDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'accounts': value['accounts'] == null ? undefined : (value['accounts'].map(AccountOptionDtoToJSON)),
        'statiOpportunity': value['statiOpportunity'],
    };
}
